export default __webpack_public_path__ + "static/media/drzewko2.c45936e1.jpg";